import { Icon } from "@opendash/icons";
import React, { memo } from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 200px;

  padding: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
`;

const IconHolder = styled.div`
  font-size: 2em;
`;

const Title = styled.div`
  text-transform: uppercase;
  font-weight: 700;
`;

const Message = styled.div`
  margin-bottom: 10px;
`;

interface Props {
  icon: string;
  iconClass?: string;
  title: string;
  message: string;
}

export const ErrorMessage = memo<Props>(function ErrorMessage({
  icon,
  iconClass,
  title,
  message,
}) {
  return (
    <Container>
      <div>
        <IconHolder>
          <Icon icon={icon} className={iconClass} />
        </IconHolder>
        <Title>{title}</Title>
        <Message>{message}</Message>
      </div>
    </Container>
  );
});
